module.exports = __webpack_public_path__ + "static/img/topleft_2.0a9a903.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topleft_2.png
// module id = jxKt
// module chunks = 1